<template>
  <div class="q_sign">
    <div class="q_text_l q_bold">注册</div>
    <div class="q_text_s q_color_gray q_mar_t10px">您好，欢迎来到招远市志愿者平台</div>
    <div class="q_mar_t40px">
      <van-field v-model="phone" type="tel" clearable placeholder="请输入手机号"/>
      <van-field v-model="code" type="number" center clearable class="q_mar_t15px" placeholder="请输入短信验证码">
        <template #button>
          <van-button size="mini" round type="primary" color="#FF5733" @click="sendCode" :disabled="isSendCode"
          >{{ codeText }}
          </van-button>
        </template>
      </van-field>
      <van-field v-model="password" clearable :type="passwordType" class="q_mar_t15px" placeholder="请输入6-16位密码">
        <template slot="right-icon">
                      <span @click="switchPasswordType">
                           <van-icon name="closed-eye" v-if="passwordType==='password'"/>
                           <van-icon name="eye" v-else />
                      </span>
        </template>
      </van-field>
      <van-field v-model="password1" clearable :type="passwordType1" class="q_mar_t15px" placeholder="请再次输入密码">
        <template slot="right-icon">
                      <span @click="switchPasswordType1">
                           <van-icon name="closed-eye" v-if="passwordType1==='password'"/>
                           <van-icon name="eye" v-else />
                      </span>
        </template>
      </van-field>
    </div>
    <div class="q_mar_t15px q_text_s">
      <span class="q_flo_right q_color_default" @click="goToSign()">去登录</span>
      <span class="q_flo_right">已有账号？</span>
    </div>
    <div class="q_center q_mar_t80px">
      <van-button class="q_btn_sign" round color="#FF5733" @click="submitRegister" :loading="buttonLoading"
                  :disabled="buttonLoading"
                  loading-type="spinner"
                  loading-text="正在注册">注 册
      </van-button>
    </div>
    <img src="@/assets/image/sign.png" style="width: 100%;position: fixed;bottom: 0;z-index: -1;left: 0;"/>
  </div>
</template>

<script>
import {validatePhoneNumber} from "@/utils/validate";
import {Encrypt} from "@/utils/crypto";
import {getCode, registerUser} from "@/api/login";
import Vue from 'vue';
import { Icon } from 'vant';
import {wxCloseShare} from "@/utils/jiutang";
Vue.use(Icon);

export default {
  name: 'Register',
  props: {
    msg: String
  },
  data() {
    return {
      passwordType:'password',
      passwordType1:'password',
      phone: '',
      code: '',
      password: '',
      password1: '',
      //发送验证码是否显示
      isSendCode: false,
      //验证码重新发送秒
      second: 60,
      //验证码显示文本
      codeText: '发送验证码',
      buttonLoading: false
    }
  },
  created() {
    wxCloseShare()
  },
  methods: {
    /**
     * 发送验证码
     */
    sendCode() {
      if (!this.phone) {
        this.$modal.alert('请输入手机号')
        return
      }
      if (!validatePhoneNumber(this.phone)) {
        this.$modal.alert('手机号格式有误')
        return
      }
      //发送验证码
      this.isSendCode = true
      let data = {'phone': this.phone, 'type': '1'}
      this.$modal.loading('正在发送')
      getCode(data).then(res => {
        this.$modal.closeLoading()
        this.$modal.success("发送成功")
        let second = this.second
        let timer = setInterval(() => {
          second--
          this.timeFun(second, timer)
        }, 1000)
      }).catch(()=>{
        this.$modal.closeLoading()
      }).finally(() => {
        this.isSendCode = false
      })
    },
    /**
     * 倒计时
     * @param timer
     */
    timeFun(second, timer) {
      setTimeout(() => {
        if (second != 0) {
          this.isSendCode = true
          this.codeText = second + '秒后重新发送'
        } else {
          this.isSendCode = false
          this.codeText = '发送验证码'
          clearInterval(timer)
        }
      }, 0)
    },
    /**
     * 提交注册
     */
    submitRegister() {
      if (!this.phone) {
        this.$modal.alert('请输入手机号')
        return
      }
      if (!validatePhoneNumber(this.phone)) {
        this.$modal.alert('手机号格式有误')
        return
      }
      if (!this.code) {
        this.$modal.alert('请输入短信验证码')
        return
      }
      if (!this.password || this.password.length < 6 || this.password.length > 16) {
        this.$modal.alert('请输入6-16位密码')
        return
      }
      //特殊符号包含（. _ ~ ! @ # $ ^ & *）
      //密码必须由字母、数字、特殊符号组成，区分大小写
      const rule = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{6,16}$/;
      if (rule.test(this.password)) {
        console.log("密码验证通过");
      } else {
        this.$modal.alert('密码必须由6-16位字母、数字、特殊符号(. _ ~ ! @ # $ ^ & *)组成');
        return;
      }
      if (!this.password1) {
        this.$modal.alert('请再次输入密码')
        return
      }
      if (this.password != this.password1) {
        this.$modal.alert('两次密码输入不一致，请重新输入')
        return
      }

      this.buttonLoading = true
      let data = {'phone': this.phone, 'password': Encrypt(this.password), 'code': this.code}
      //注册用户
      registerUser(data).then(res => {
        this.$modal.success("注册成功")
        this.reset()
        setTimeout(() => {
          this.$router.push({
            path: '/mine/sign'
          });
        }, 1500);
      }).finally(() => {
        this.buttonLoading = false
      })

    },
    /**
     * 重置表单
     */
    reset() {
      this.phone = ''
      this.code = ''
      this.password = ''
      this.password1 = ''
      this.isSendCode = false
      this.second = 5
      this.codeText = '发送验证码'
      this.buttonLoading = false
    },
    goToSign() {
      this.$router.push({
        path: '/mine/Sign'
      });
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    switchPasswordType1() {
      this.passwordType1 = this.passwordType1 === 'password' ? 'text' : 'password'
    },
  },
}
</script>
